import { h } from 'preact';
import { useNewStore, usePlayerContext, useStyles } from '../../../common/hooks';
import Position from '../../../common/utils/Position';
import { withBreakPoints } from '../../hoc';
import { Label } from '../common';
import { MAIN_WRAPPER_PADDING } from '../wrappers/styles';
import { AD_INFOS_WRAPPER_STYLE } from './styles';
import { AD_INFOS_LABEL_STYLE } from '../../../common/components/styles';

function AdInfos({
  mobile, tablet
}) {
  const player = usePlayerContext();
  const { isDAI } = useNewStore('media', player);
  const { showCountdown, isAd } = useNewStore('ad', player);
  const { pubLabel } = useNewStore('ui', player);

  const setStyles = useStyles();

  return (
    (isAd || showCountdown)
      ? (
        <div style={{ ...AD_INFOS_WRAPPER_STYLE, ...setStyles(MAIN_WRAPPER_PADDING), paddingBottom: 0 }}>
          <Position>
            {pubLabel && <Label message={pubLabel} blur="medium" style={AD_INFOS_LABEL_STYLE} />}
            {
              (mobile || tablet) && !showCountdown
              && (
                <Label
                  message="+ d'infos"
                  blur="medium"
                  onClick={() => player.adClick(isDAI ? 'dai' : 'freewheel')}
                  style={AD_INFOS_LABEL_STYLE}
                  opaque
                />
              )
            }
          </Position>
        </div>
      ) : null
  );
}

export default withBreakPoints(AdInfos);
